import Currency from '@/domain/currency/entity/currency.entity';
import ItemsSimplified from './billing-detailed-entitys.ts/items-simplified-entity';
import BillingListBase from './billing-list-base.entity';

export default class BillingListSimplified extends BillingListBase {
  items: ItemsSimplified[] = [];

  currencyFrom: Currency;

  constructor(obj: any = {}) {
    super(obj);
    if (obj.items) {
      this.items = obj.items.map((it) => new ItemsSimplified(it));
    }
    this.currencyFrom = Currency.of(obj.currencyFrom);
  }

  get itemsJoined(): string {
    return this.items.map((el: ItemsSimplified) => `${el.description}`).join(', ')
  }

  get itemsGrouped(): string {
    const length = this.items.length;
    return length > 1 ? `${length} Itens` : this.items[0].description;
  }

  get beneficiariesJoined(): string {
    return this.items.filter((el: ItemsSimplified) => el.beneficiary)
      .map((el: any) => `${el.beneficiary}`).join(', ')
  }

  get discountObservationJoined(): String {
    return this.items.map(
      (el: ItemsSimplified) => `${el?.discountHistory?.discountObservation || ''}`,
    ).join(', ');
  }

  get discountJustificationJoined(): String {
    return this.items.map(
      (el: ItemsSimplified) => `${el?.discountHistory?.discountJustification || ''}`,
    ).join(', ');
  }

  get discountResponsibleJoined(): String {
    return this.items.map(
      (el: ItemsSimplified) => `${el?.discountHistory?.discountResponsible || ''}`,
    ).join(', ');
  }

  get discountDiscountTypeJoined(): String {
    return this.items.map(
      (el: ItemsSimplified) => `${el.discountHistory?.discountType || ''}`,
    ).join(', ');
  }

  get discountDiscountValueJoined(): string {
    return 'Clique no botão \'Filtrar\' para carregar esse valor';
  }
}
